import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SingleDatePicker } from "react-dates";
import { TimePicker } from "antd";
import { Editor } from "react-draft-wysiwyg";
import {
  Button,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

import moment from "moment";
import draftToHtml from "draftjs-to-html";
import "react-dates/initialize";

import {
  dropdownIcon,
  watchIcon,
  CalendarIcon,
} from "../../../Shared/SVGs/Shared";
import { updateCampaignFields, updateCampaignState } from "../CampaignActions";
import FormStepsModal from "./FormStepsModal";
import toolbar from "../../../utility/toolbar";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "react-dates/lib/css/_datepicker.css";
import "./react_dates_overrides.css";
import styled from "styled-components";

const infoIcon = require("@src/assets/images/vyrill/videos/info.png").default;
const CloseIcon = require("@src/assets/images/vyrill/videos/close.svg").default;
import youtube from "@src/assets/images/vyrill/reports/youtube_icon.png";
import tiktok from "@src/assets/images/vyrill/icons/tiktok_icon.png";
import instagram from "@src/assets/images/vyrill/icons/instagram_icon.png";
import upload from "@src/assets/images/vyrill/icons/upload_icon.png";
import googledrive from "@src/assets/images/vyrill/icons/google_drive_icon.png";
import dropbox from "@src/assets/images/vyrill/icons/dropbox_icon.png";

const platformData = [
  { label: "YouTube Link", name: "YouTube", icon: youtube },
  { label: "TikTok Link", name: "TikTok", icon: tiktok },
  { label: "Instagram Link", name: "Instagram", icon: instagram },
  { label: "Google Drive Link", name: "GoogleDrive", icon: googledrive },
  { label: "Dropbox Link", name: "Dropbox", icon: dropbox },
  { label: "Upload Video", name: "Upload", icon: upload },
];

const Step2 = ({}) => {
  const [desc, setDesc] = useState(false);
  const [brand, setBrand] = useState(false);
  const toggleBrandTooltip = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDesc(!desc);
  };
  const toggleBrand1Tooltip = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setBrand(!brand);
  };
  const form = useSelector((state) => state.campaign_states.form);
  const start_time = useSelector(
    (state) => state.campaign_states.form.start_time
  );
  const end_time = useSelector((state) => state.campaign_states.form.end_time);
  const campaign_video_length = useSelector(
    (state) => state.campaign_states.form.campaign_video_length
  );

  const campaign_video_length_type = useSelector(
    (state) => state.campaign_states.form.campaign_video_length_type
  );
  const description_editor_state = useSelector(
    (state) => state.campaign_states.form.description_editor_state
  );
  const brand_instruction_editor_state = useSelector(
    (state) => state.campaign_states.form.brand_instruction_editor_state
  );

  // const raw = convertToRaw(description_editor_state?.getCurrentContent());
  // const converted = convertFromRaw(raw);

  // console.log("raw", raw);
  // console.log("convertFromRaw", converted);

  const timezones = useSelector((state) => state.campaign_states.timezones);

  const [videoTimeError, setVideoTimeError] = useState("");
  const [hover, setHover] = useState(false);

  const [date1, setDate1] = useState(
    form.end_date ? moment(form.end_date) : null
  );
  const [focused, setFocused] = useState(null);
  const [focused1, setFocused1] = useState(null);
  const [dropdown1Open, setDropdown1Open] = useState(false);

  const togglerDropdown = () => setDropdown1Open(true);
  const handleFocusChange = ({ focused }) => {
    setFocused(focused);
  };
  const handleFocusChange1 = ({ focused }) => {
    setFocused1(focused);
  };
  const dispatch = useDispatch();

  const [dropdown2Open, setDropdown2Open] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpen1, setDropdownOpen1] = useState(false);

  const toggleTimezone = () => setDropdown2Open(!dropdown2Open);
  const handleOptionTimezone = (option) => {
    dispatch(updateCampaignFields({ campaign_timezone: option }));
    setDropdown2Open(false);
  };
  const handleRewardTypeSelect = (option) => {
    dispatch(updateCampaignFields({ campaign_reward_type: option }));
    setDropdownOpen(false);
  };
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const handleTimeTypeSelect = (option) => {
    dispatch(updateCampaignFields({ campaign_video_length_type: option }));
    setDropdownOpen1(false);
  };
  const toggleTimeDropdown = () => setDropdownOpen1(!dropdownOpen1);

  const activeStep = useSelector((state) => state.campaign_states.activeStep);

  const handleStartDateChange = (newDate) => {
    dispatch(updateCampaignFields({ start_date: newDate }));
  };

  const handleDateChange2 = (newDate) => {
    setDate1(newDate);
    dispatch(updateCampaignFields({ end_date: newDate, ongoing: false }));
  };

  const formattedEndDate = form.end_date
    ? moment(form.end_date).format("MM/DD/YYYY")
    : null;

  useEffect(() => {
    if (form.end_date || form.ongoing) {
      const timeoutId = setTimeout(() => {
        setDropdown1Open(false);
      }, 10);
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [form.end_date, form.ongoing]);

  const handleOptionSelect = (option) => {
    setDropdown1Open(false);
    if (form.ongoing === "Ongoing") {
      dispatch(updateCampaignFields({ end_date: "", end_time: "" }));
    }
    dispatch(
      updateCampaignFields({ ongoing: true, end_date: "", end_time: "" })
    );
  };

  const handleTimeChange = (time) => {
    dispatch(updateCampaignFields({ start_time: time }));
  };
  const handleTimeChange1 = (time) => {
    dispatch(updateCampaignFields({ end_time: time }));
  };
  const calenderDropdown = (
    <DropdownMenu style={{ minWidth: "0", padding: "0" }}>
      <DropdownItem
        style={{
          width: "160px",
        }}
        onClick={() => handleOptionSelect("Ongoing")}
      >
        <div className="d-flex justify-content-between">
          <div className="date-text">Ongoing</div>
          <div>{watchIcon}</div>
        </div>
      </DropdownItem>
      <div style={{ height: "45px", marginTop: "5px" }}>
        <SingleDatePicker
          date={date1}
          onDateChange={handleDateChange2}
          focused={focused1}
          onFocusChange={handleFocusChange1}
          id="your_unique_isd"
          numberOfMonths={1}
          showDefaultInputIcon
          hideKeyboardShortcutsPanel
        />
      </div>
    </DropdownMenu>
  );

  const ongoingOption = (
    <div>
      {!form.end_date ? (
        <Input
          className="form-field"
          value={"11:59 pm"}
          disabled
          style={{
            background: "transparent",
            color: "lightGray",
            width: "102px",
            fontSize: "16px",
          }}
        />
      ) : (
        <div>
          <TimePicker
            onChange={handleTimeChange1}
            value={end_time}
            format="hh:mm a"
            placeholder="11:59 pm"
            className="form-field me-1"
            style={{ width: "102px", padding: "0px 8px" }}
            use12Hours
            minuteStep={5}
            showNow={false}
            suffixIcon={""}
            needConfirm={false}
          />
        </div>
      )}
    </div>
  );
  const selectOption = (
    <div>
      {form.end_date ? (
        <div className="date-text d-flex gap-1 align-items-center">
          {CalendarIcon}
          {formattedEndDate}
        </div>
      ) : form.ongoing ? (
        <div className="date-text d-flex justify-content-between">
          <div>{form.ongoing ? "Ongoing" : ""}</div>
          <div>{watchIcon}</div>
        </div>
      ) : (
        <div className="d-flex justify-content-between">
          <p className="light-text">Select</p>
          <p className="pe-2"> {dropdownIcon}</p>
        </div>
      )}
    </div>
  );

  const isNextButtonDisabled =
    !form.campaign_description ||
    form.campaign_description === "<p></p>\n" ||
    !form.start_date ||
    videoTimeError ||
    (!form.ongoing && (!form.end_date || !form.end_time)) ||
    (!form.ongoing && !form.end_time) ||
    (form.ongoing && !form.start_time);

  const timezone = timezones.map((option, i) => {
    if (form.campaign_timezone === option.value) {
      return (
        <div
          className="d-flex justify-content-between"
          style={{ marginTop: "-4px" }}
          key={i}
        >
          <p key={option.value} className="">
            {option.label}
          </p>
          <p>{dropdownIcon}</p>
        </div>
      );
    }
  });

  const style = {
    background: "#fff",
    color: "black",
    width: "233px",
    height: "50px",
    borderBottom: "1px solid #c4c4c4",
  };

  const rewardDropdown = (
    <DropdownMenu>
      <DropdownItem
        style={style}
        onClick={() => handleRewardTypeSelect("Cash")}
      >
        <div className="reward-dropdown">
          <div>Cash</div>
          <div>$$</div>
        </div>
      </DropdownItem>
      <DropdownItem
        style={style}
        onClick={() => handleRewardTypeSelect("Discount")}
      >
        <div className="reward-dropdown">
          <div>Discount</div>
          <div>%</div>
        </div>
      </DropdownItem>
      <DropdownItem
        style={{ ...style, marginBottom: "-11px" }}
        onClick={() => handleRewardTypeSelect("Other")}
      >
        <div className="reward-dropdown">
          <div>Other</div>
          <div>...</div>
        </div>
      </DropdownItem>
    </DropdownMenu>
  );

  const timeDurationDropdown = (
    <DropdownMenu>
      <DropdownItem onClick={() => handleTimeTypeSelect("sec")}>
        <div>sec</div>
      </DropdownItem>
      <DropdownItem onClick={() => handleTimeTypeSelect("min")}>
        <div>min</div>
      </DropdownItem>
      <DropdownItem onClick={() => handleTimeTypeSelect("hr")}>
        <div>hr</div>
      </DropdownItem>
    </DropdownMenu>
  );

  const rewardType = (
    <div
      className="d-flex align-items-center justify-content-between"
      style={{ width: "219px" }}
    >
      <p className="me-2">
        {form.campaign_reward_type ? (
          form.campaign_reward_type
        ) : (
          <span className="light-text">Select the type of reward</span>
        )}
      </p>
      <p>{dropdownIcon}</p>
    </div>
  );
  const timeDurationType = (
    <div className="d-flex align-items-center justify-content-between">
      <p>
        {campaign_video_length_type ? (
          campaign_video_length_type
        ) : (
          <span className="light-text">Select</span>
        )}
      </p>
      <p>{dropdownIcon}</p>
    </div>
  );

  const selectedrewardinput = (
    <div style={{ width: "108px", height: "50px" }}>
      <div className="dollor-sign">
        {form.campaign_reward_type === "Cash" ? (
          "$"
        ) : "$" && form.campaign_reward_type === "Discount" ? (
          "%"
        ) : "%" && form.campaign_reward_type === "Other" ? (
          <div style={{ color: "transparent" }}>...</div>
        ) : (
          "$"
        )}
      </div>
      {form.campaign_reward_type === "Other" ? (
        <div>
          <Input
            placeholder="Specify the reward for your campaign participants here."
            type="textarea"
            className="form-field reward-other"
            value={form.campaign_reward}
            onChange={(e) => {
              const inputValue = e.target.value;
              const wordCount = inputValue?.trim()?.split(/\s+/)?.length;
              if (wordCount <= 141) {
                dispatch(updateCampaignFields({ campaign_reward: inputValue }));
              }
            }}
          />
          <div className="word-limit light-text">
            Word limit{" "}
            {141 - form?.campaign_reward.trim()?.split(/\s+/)?.length}.
          </div>
        </div>
      ) : (
        <Input
          className="form-field ps-3 dollor-input"
          type="number"
          min={0}
          max={form.campaign_reward_type === "Discount" ? 100 : undefined}
          value={form.campaign_reward}
          placeholder="100"
          onChange={(e) => {
            dispatch(updateCampaignFields({ campaign_reward: e.target.value }));
          }}
        />
      )}
    </div>
  );

  const handleContentStateChange = (contentState) => {
    dispatch(
      updateCampaignFields({ campaign_description: draftToHtml(contentState) })
    );
  };
  const handleBrandContentStateChange = (contentState) => {
    dispatch(
      updateCampaignFields({ brand_instruction: draftToHtml(contentState) })
    );
  };

  const handleEditorStateChange = (editorState) => {
    dispatch(updateCampaignFields({ description_editor_state: editorState }));
  };

  const handleBrandEditorStateChange = (editorState) => {
    dispatch(
      updateCampaignFields({ brand_instruction_editor_state: editorState })
    );
  };
  const handlePlatformChange = (value) => {
    let updatedPlatforms = [...form.campaign_upload_platform];
    if (updatedPlatforms.includes(value)) {
      updatedPlatforms = updatedPlatforms.filter(
        (platform) => platform !== value
      );
    } else {
      updatedPlatforms.push(value);
    }
    dispatch(
      updateCampaignFields({ campaign_upload_platform: updatedPlatforms })
    );
  };

  const handleTooltipFunction = (click, toggleTooltip, tooltipText, style) => {
    return (
      <>
        <span>
          <img
            style={{ marginLeft: "10px", marginBottom: "3px" }}
            role="button"
            width={13}
            src={infoIcon}
            onClick={toggleTooltip}
          />
        </span>
        {click && (
          <div style={{ position: "absolute" }}>
            <div className="tooltip-vyrill-data-logo" style={style}>
              <img
                role="button"
                onClick={toggleTooltip}
                className="opacity-100 cross"
                src={CloseIcon}
                style={{ width: "24px" }}
              />
              {tooltipText}
            </div>
          </div>
        )}
      </>
    );
  };
  return (
    <>
      <div className="form-step-2">
        <FormGroup>
          <div className="d-flex justify-content-between">
            <Label className="form-field-label">
              Campaign Description
              <span style={{ color: "#E62580" }}>*</span>
              {handleTooltipFunction(
                desc,
                toggleBrandTooltip,
                "This section provides a detailed overview of the campaign, including its objectives, target audience, and key messaging. Understanding the campaign description helps you align your creative efforts with the overarching goals and strategy.",
                { left: "240px" }
              )}
            </Label>
            <FormStepsModal
              step={2}
              content={
                "Add campaign description, start date/time, end date/time, and reward. Campaigns with rewards attract more participants."
              }
            />
          </div>

          <Editor
            editorState={description_editor_state}
            toolbarClassName="editor-toolbar"
            wrapperClassName="editor-wrapper"
            editorClassName="editor-text-area-style"
            onEditorStateChange={handleEditorStateChange}
            onContentStateChange={handleContentStateChange}
            toolbar={toolbar}
            // localization={localization}
            placeholder="This information will be made public. Please include all the instructions and requirements for participating in the campaign. Ensure that it is clear, captivating, and easy to follow!"
            // spellCheck
            id="campaign_description"
            stripPastedStyles
            // toolbarCustomButtons={[<CustomComponent />]}
          />
        </FormGroup>
        <FormGroup>
          <div className="d-flex justify-content-between">
            <Label className="form-field-label">
              Brand Instructions
              {handleTooltipFunction(
                brand,
                toggleBrand1Tooltip,
                "If you have any brand guidelines and specifications, add them in this section that ensure consistency across all videos. This includes details on logo usage, color schemes, typography (if any), questions that you would like the customers to reply and tone of voice. ",
                { left: "200px" }
              )}
            </Label>
          </div>

          <Editor
            editorState={brand_instruction_editor_state}
            toolbarClassName="editor-toolbar"
            wrapperClassName="editor-wrapper"
            editorClassName="editor-text-area-style"
            onEditorStateChange={handleBrandEditorStateChange}
            onContentStateChange={handleBrandContentStateChange}
            toolbar={toolbar}
            // localization={localization}
            placeholder="This information will be made public. Please include all the instructions and requirements for participating in the campaign. Ensure that it is clear, captivating, and easy to follow!"
            // spellCheck
            id="campaign_description"
            stripPastedStyles
            // toolbarCustomButtons={[<CustomComponent />]}
          />
        </FormGroup>

        <div className="d-flex justify-content-between">
          <div>
            <FormGroup>
              <div className="d-flex justify-content-between">
                <Label className="form-field-label">
                  Start Date
                  <span style={{ color: "#E62580" }}>*</span>
                </Label>
              </div>
              <div
                className="form-field"
                style={{ width: "160px", height: "40px", padding: "0px 4px" }}
              >
                <SingleDatePicker
                  date={form.start_date}
                  onDateChange={handleStartDateChange}
                  focused={focused}
                  onFocusChange={handleFocusChange}
                  id="your_unique_id"
                  numberOfMonths={1}
                  showDefaultInputIcon
                  hideKeyboardShortcutsPanel
                />
              </div>
            </FormGroup>
          </div>
          <FormGroup className="set-time">
            <Label className="form-field-label">
              Time<span style={{ color: "#E62580" }}>*</span>
            </Label>
            <div>
              <TimePicker
                onChange={handleTimeChange}
                value={start_time}
                format="hh:mm a"
                placeholder="09:41 am"
                className="form-field me-1"
                style={{ width: "102px", padding: "0px 8px" }}
                use12Hours
                minuteStep={5}
                showNow={false}
                suffixIcon={""}
                needConfirm={false}
              />
            </div>
          </FormGroup>
          <div>
            <div>
              <FormGroup>
                <div className="d-flex justify-content-between">
                  <Label className="form-field-label">
                    End Date
                    <span style={{ color: "#E62580" }}>*</span>
                  </Label>
                </div>
                <Dropdown isOpen={dropdown1Open} toggle={togglerDropdown}>
                  <DropdownToggle
                    className="form-field"
                    style={{
                      background: "#FFF",
                      color: "black",
                      width: "160px",
                      // marginLeft: "20px",
                    }}
                  >
                    {/* selectedOption === calender */}
                    {selectOption}
                  </DropdownToggle>
                  {calenderDropdown}
                </Dropdown>
              </FormGroup>
            </div>
          </div>
          <FormGroup className="set-time">
            <Label className="form-field-label">
              Time
              {!form.ongoing && <span style={{ color: "#E62580" }}>*</span>}
            </Label>
            {ongoingOption}
          </FormGroup>
        </div>

        <Row className="form-control-row align-items-center">
          <Col sm={2}>
            <Label style={{ fontSize: "15px", color: "black" }}>
              Time Zone
            </Label>
          </Col>
          <Col>
            <Dropdown isOpen={dropdown2Open} toggle={toggleTimezone}>
              <DropdownToggle
                style={{
                  width: "365px",
                  height: "35px",
                  borderRadius: "2px",
                }}
              >
                {/* select reward type */}
                {timezone}
              </DropdownToggle>
              <DropdownMenu
                onChange={(e) =>
                  dispatch(
                    updateCampaignFields({ campaign_timezone: e.target.value })
                  )
                }
                value={form.campaign_timezone}
              >
                {timezones.map((option, index) => (
                  <DropdownItem
                    key={index}
                    className="dropdown-item"
                    style={{
                      width: "365px",
                      marginBottom:
                        index < timezones.length - 1 ? "0px" : "-9px",
                    }}
                    onClick={() => handleOptionTimezone(option.value)}
                  >
                    <div>{option.label}</div>
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </Col>
        </Row>
        <Row className="form-control-row  mt-5">
          <Col>
            <FormGroup>
              <Label className="form-field-label">Campaign Reward</Label>
              <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle
                  className="custom-dropdown-toggle"
                  style={{
                    background: " #FFF",
                    color: "black",
                    height: "50px",
                    borderRadius: "2px",
                  }}
                >
                  {/* select reward type */}
                  {rewardType}
                </DropdownToggle>
                {rewardDropdown}
              </Dropdown>
            </FormGroup>
          </Col>
          <Col className="ms-5">
            <FormGroup>
              <Label className="form-field-label"></Label>
              {selectedrewardinput}
            </FormGroup>
          </Col>
        </Row>

        <Row
          className="form-control-row"
          style={{
            marginTop: form.campaign_reward_type === "Other" && "120px",
          }}
        >
          <div className="d-flex align-items-center">
            <div className="form-field-label" style={{ marginRight: "80px" }}>
              Campaign Video Entry Limit{" "}
              {/* <span style={{ color: "#E62580" }}>*</span> */}
            </div>
            <div>
              <Input
                className="form-field ps-2"
                style={{ height: "50px", width: "108px" }}
                type="number"
                value={
                  form.campaign_video_limit > 0
                    ? form.campaign_video_limit
                    : null
                }
                placeholder="200"
                onChange={(e) => {
                  dispatch(
                    updateCampaignFields({
                      campaign_video_limit: Number(e.target.value),
                    })
                  );
                }}
              />
            </div>
          </div>
        </Row>
        <Row className="form-control-row mt-3">
          <div className="d-flex align-items-center">
            <div
              className="form-field-label"
              style={{ marginRight: "115px", position: "relative" }}
            >
              Campaign Video Length{" "}
            </div>
            <div>
              <Input
                className="form-field ps-2"
                style={{ height: "50px", width: "66px" }}
                type="number"
                id="timeInput"
                name="timeInput"
                value={campaign_video_length}
                onChange={(e) => {
                  dispatch(
                    updateCampaignFields({
                      campaign_video_length: e.target.value,
                    })
                  );
                }}
                placeholder="3"
              />
            </div>
            <div className="ms-1 time-duration-dropdown">
              <Dropdown isOpen={dropdownOpen1} toggle={toggleTimeDropdown}>
                <DropdownToggle
                  style={{
                    background: " #FFF",
                    color: "black",
                    height: "50px",
                    width: "83px",
                    borderRadius: "2px",
                    padding: "13px 8px",
                  }}
                >
                  {/* select reward type */}
                  {timeDurationType}
                </DropdownToggle>
                {timeDurationDropdown}
              </Dropdown>
            </div>
          </div>
        </Row>

        <Row className="form-control-row mt-5" style={{ width: "1000px" }}>
          <div className="d-flex align-items-center">
            <div style={{ marginRight: "85px", position: "relative" }}>
              <div className="form-field-label">Video Submission Platform</div>
              <div style={{ lineHeight: "40px" }}>(Select all that apply)</div>
            </div>
            {platformData.map((platform, index) => (
              <div key={index}>
                <label>
                  <input
                    type="checkbox"
                    style={{ marginTop: "10px" }}
                    onChange={() => handlePlatformChange(platform.name)}
                    checked={form.campaign_upload_platform?.includes(
                      platform.name
                    )}
                  />
                  <img
                    src={platform.icon}
                    width={30}
                    style={{ marginLeft: "9px" }}
                  />
                  <div
                    style={{
                      lineHeight: "40px",
                      fontSize: "10px",
                      color: "black",
                      marginRight: "30px",
                      // marginLeft: "8px",
                    }}
                  >
                    {platform.label}
                  </div>
                </label>
              </div>
            ))}
          </div>
        </Row>

        <div className="center mt-5 mb-5">
          <Button
            className="campaign-button"
            size="lg"
            color={`${isNextButtonDisabled} ? secondary : primary`}
            onClick={() =>
              dispatch(updateCampaignState({ activeStep: activeStep + 1 }))
            }
            disabled={isNextButtonDisabled}
            style={{ background: isNextButtonDisabled ? "#C4C4C4" : "" }}
          >
            Next
          </Button>
        </div>
      </div>
    </>
  );
};

export default Step2;
